import Experiment from '@mc/experiments-react'
import { TrackingContainer } from '@mc/visibility'
import { trackExperimentViewed } from '@mc/track-event'

import { NON_PROMO_STICKY_FOOTER_REDESIGN_EXP_KEY } from './constants'
import { NonPromoStickyFooterRedesignVariant } from './components/NonPromoStickyFooterRedesignVariant'

interface NonPromoStickyFooterRedesignExperimentProps {
  control: React.ReactNode
  SignUpCta: React.ComponentType
}

export const NonPromoStickyFooterRedesignExperiment = ({
  control,
  SignUpCta,
}: NonPromoStickyFooterRedesignExperimentProps) => (
  <TrackingContainer
    onFirstVisible={() =>
      trackExperimentViewed(NON_PROMO_STICKY_FOOTER_REDESIGN_EXP_KEY)
    }
  >
    <Experiment
      name={NON_PROMO_STICKY_FOOTER_REDESIGN_EXP_KEY}
      control={() => control}
      variant_1={() => (
        <NonPromoStickyFooterRedesignVariant SignUpCta={SignUpCta} />
      )}
      track={false}
    />
  </TrackingContainer>
)
